export default __webpack_public_path__ + "static/media/salad-prive-1@2x.4b7d57ae.png";